import { setWithinPercentageRange } from "@@/utilities/set-within-range";
import type { RGBA } from "../rgba-color/rgba-color";

const rgbaToString = (rgba: RGBA) => {
    const { red, green, blue, alpha } = rgba;
    const _alpha = setWithinPercentageRange(alpha ?? 1);
    return `rgba(${red},${green},${blue},${_alpha})`;
};

export { rgbaToString };
